const fonts = {
  roboto: `'Roboto', sans-serif`,
  poppins: `'Poppins', sans-serif`,
  geist: `'Geist', 'Roboto', sans-serif`,
  prata: `'Prata', 'Times New Roman', serif`,
  robotoMono: `'Roboto Mono', ui-monospace, monospace`,
};

export default fonts;
